export default "__VITE_ASSET__7d053629__"